import React, { useEffect } from "react";
import handballCourt from "../../../../assets/handball/court.png";
import handballRegions from "../../../../assets/handball/court_zones.png";
import { ReactComponent as LeftArrowPosSVG } from "../../../../assets/handball/left-pos-arrow.svg";
import { ReactComponent as RightArrowPosSVG } from "../../../../assets/handball/right-pos-arrow.svg";

const Court = ({ onClick, currentState }) => {
  const possessionIndex = (currentState?.entities ?? []).findIndex(
    (entity) => entity.hasPossession
  );

  useEffect(() => {
    const root = document.querySelector(":root");

    (currentState?.entities ?? []).forEach((entity, idx) => {
      root.style.setProperty(`--entity-${idx}-color`, entity.primaryColor);
    });
  }, [currentState.entities]);

  return (
    <>
      <img
        id="base-play-area"
        alt="base-play-area"
        src={handballCourt}
        style={{ position: "absolute" }}
        onClick={onClick}
        draggable={false}
      />
      <img
        id="base-play-area-regions"
        alt="base-play-area-regions"
        src={handballRegions}
        style={{ opacity: "0", width: "100%" }}
        draggable={false}
        onClick={onClick}
      />
      {possessionIndex === 0 && (
        <RightArrowPosSVG
          className="handball-possession-indicator right"
          alt="possession-indicator"
        />
      )}

      {possessionIndex === 1 && (
        <LeftArrowPosSVG
          className="handball-possession-indicator left"
          alt="possession-indicator"
        />
      )}
    </>
  );
};

export default Court;
